<template>
	<div class="c-generations">
		<PageHeader title="AI Generations" :showMenu="true">
			<template v-slot:title> Your saved AI generations </template>
		</PageHeader>
		<div class="c-generations__inner">
			<List></List>
		</div>
	</div>
</template>

<script>
import PageHeader from '@swipekit/components/utils/page-header';
import List from './list';

export default {
	components: {
		PageHeader,
		List,
	},

	data: function () {
		return {};
	},

	methods: {},
};
</script>

<style lang="scss">
.c-generations {
	&__inner {
		position: relative;
		z-index: 1;

		> header {
			display: flex;
			justify-content: center;
			align-items: center;
			padding: 1rem var(--spacer-sm);
		}
	}
}
</style>
